import React, { Component } from 'react'

import { Cards, Button } from 'Components'
import Terms from 'Pages/DetailOffers/Components/Terms'
import NotFound from 'Pages/NotFound'

import DOOgether from 'Assets/logo/doogether.png'
import IconCalendar from 'Assets/icon/calendar.png'
import IconOffer from 'Assets/icon/offer.png'

export default class DetailOffers extends Component {
   constructor(props) {
      super(props)

      this.state = {
         pathname: window.location.pathname,
         number: null,
         expired: '28 Februari 2021',
      }
   }

   componentDidMount() {
      const { pathname } = this.state
      if (pathname === '/package-1') {
         this.setState({ number: 2 })
      } else if (pathname === '/package-2') {
         this.setState({ number: 4 })
      } else if (pathname === '/package-3') {
         this.setState({ number: 12 })
      } else {
         alert('Sorry, page not found')
      }
   }

   render() {
      const { number, expired } = this.state

      if (number === 2 || number === 4 || number === 12) {
         return (
            <div className='offers'>
               <Cards>
                  <img src={DOOgether} alt='doogether' />
                  <div className='offers__title'>
                     Enjoy DOOlive!
                     <br /> Get {number}x of 40% Discounts
                     <br /> for DOOlive classes
                  </div>
                  <div className='offers__wrapper'>
                     <div className='offers__wrapper__container'>
                        <img src={IconCalendar} alt='calendar' />
                        <div className='content'>
                           <div className='title'>Kadaluarsa</div>
                           <div className='date'>{expired}</div>
                        </div>
                     </div>
                     <div className='offers__wrapper__container'>
                        <img src={IconOffer} alt='offer' />
                        <div className='content'>
                           <div className='title'>Penawaran</div>
                           <div className='text'>{number}x Disc 40%</div>
                        </div>
                     </div>
                  </div>
                  <div className='offers__subtitle'>Sehat kini lebih gampang!</div>
                  <div className='offers__desc'>Olahraga lebih hemat 40% tanpa membership untuk {number} booking</div>
                  <Button text='Beli Sekarang' href='/payment-method' number={number} />
                  <Terms />
               </Cards>
            </div>
         )
      } else {
         return <NotFound />
      }
   }
}
